import { saveAs } from 'file-saver';
import { defaultInstance as axios } from 'src/api/instance';

const getUrlContent = async (url: string): Promise<Blob> => {
  const responseBlob = await axios.get<Blob>(url, {
    responseType: 'blob'
  });

  return responseBlob as unknown as Blob;
};

export const downloadDocumentPDF = (blob: string, fileName: string) => {
  const newBlob = new Blob([blob], { type: 'application/pdf;charset=utf-8' });
  const blobUrl = window.URL.createObjectURL(newBlob);

  const a = document.createElement('a');
  a.download = fileName;
  a.href = blobUrl;
  document.body.appendChild(a);
  a.click();
  a.remove();
};

export const downloadUrlToPdf = async (url: string, fileName: string) => {
  const content = await getUrlContent(url);
  saveAs(content, fileName);
};
